import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb'
import { Container, Row, Col, Card, CardHeader, CardBody, Table, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, Button, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { createClient } from "@supabase/supabase-js";
import { Accordion } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();

const Buyer = (props) => {
  const LargeModaltoggle = () => {
    setname("")

    setmobilenumber("")

    setemail("")

    setbuyertype("")

    setAddress("")
    setgstnumber("")

    setaadharno("")
    setdob("")
    setvehicletype("")
    setvehiclenumber("")






    setLarge(!Large)
  };
  const [edittype, setedittype] = useState("")
  const [editid, seteditid] = useState("")
  const [Large, setLarge] = useState(false);
  const [name, setname] = useState('')
  const [email, setemail] = useState('')
  const [mobilenumber, setmobilenumber] = useState('')
  const [address, setAddress] = useState('')
  const [gstnumber, setgstnumber] = useState('')

  const [aadharno, setaadharno] = useState('')
  const [dob, setdob] = useState('')
  const [vehicletype, setvehicletype] = useState('')
  const [vehiclenumber, setvehiclenumber] = useState('')
  const [clientHeight, setclientHeight] = useState("")
  const [buyertype, setbuyertype] = useState("")

  const [customer_type, setcustomer_type] = useState([])
  const [buyer_detail, setbuyer_detail] = useState([])

  const [vehicle_type, setvehicle_type] = useState([])
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const supabase = createClient(supabaseUrl, supabaseKey);
  useEffect(async () => {
    if (localStorage.getItem("usertype") != "Supplier") {
      window.history.back()
    }

    let { data: customer_type, error } = await supabase
      .from('customer_type_details')
      .select('*')

    if (error === null) {

      setcustomer_type(customer_type)
    }





    let { data: vehicle_type, error3 } = await supabase
      .from('vehicle_type_details')
      .select('*')
    if (error3 === undefined) {
      setvehicle_type(vehicle_type)
    }
    getBuyerdetail()
  }, [])

  async function getBuyerdetail() {
    let { data: Buyer_Details, error } = await supabase
      .from('Buyer_details')
      .select('*')
      .eq("createdBy", localStorage.getItem("useremail"))
    console.log(Buyer_Details)
    if (Buyer_Details !== null && Buyer_Details.length > 0) {
      setbuyer_detail(Buyer_Details)
      setTimeout(() => {
        setclientHeight(window.innerHeight * 0.71)

      }, 1000)
    } else {
      // toast.error("No Buyer Details Found")
      setbuyer_detail([])
    }
  }

  const randomUsername = () => {
    return `${Date.now().toString().substr(-4)}`;
  };
  const UpdateUser = async (buyerid) => {
    setLarge(!Large)
    setedittype("updated")
    seteditid(buyerid)
    let { data: Buyer_Details, error } = await supabase
      .from('Buyer_details')
      .select('*')
      .eq('customer_id', buyerid)

    if (Buyer_Details !== null && Buyer_Details.length > 0) {
      setname(Buyer_Details[0].customer_name)
      setmobilenumber(Buyer_Details[0].customer_phone.toString().slice(2, 12))
      setemail(Buyer_Details[0].customer_email)
      setbuyertype(Buyer_Details[0].customer_type)
      setAddress(Buyer_Details[0].customer_address)
      setgstnumber(Buyer_Details[0].customer_gstnumber)
      if (Buyer_Details[0].customer_aadhar_no === null) {
        setaadharno("")
      } else {
        setaadharno(Buyer_Details[0].customer_aadhar_no)
      }
      if (Buyer_Details[0].customer_dob === "") {
        setdob("")
      } else {
        setdob(Buyer_Details[0].customer_dob)
      }

      setvehicletype(Buyer_Details[0].customer_vehicletype)
      setvehiclenumber(Buyer_Details[0].customer_vehiclenumber)
    }
  }
  const DeleteUser = async (buyerid) => {
    let { data: user_Details, error1 } = await supabase
      .from('User_Details')
      .delete()
      .eq('user_id', buyerid)

    if (user_Details !== null && user_Details.length > 0) {
      let { data: Buyer_Details, error } = await supabase
        .from('Buyer_details')
        .delete()
        .eq('customer_id', buyerid)

      if (Buyer_Details !== null && Buyer_Details.length > 0) {

        toast.success("Buyer Deleted Successfully")
        getBuyerdetail()


      } else {
        toast.error("Error in Deleting Buyer")
      }
    } else {
      toast.error("Error in Deleting Buyer")
    }
  }
  const validatevehicleno = (vehicleno) => {
    var vehreg = /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/
    if (vehicleno.length == 10 || vehicleno.length == 9) {
      return true
    } else {
      return false
    }
  }
  const validateaadharno = (aadharno) => {
    var reg = /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/;
    if (reg.test(aadharno)) {
      return true;
    } else {
      return false;
    }

  }
  const validategst = (gst) => {
    var gstreg = /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/
    if (gstreg.test(gst)) {
      return true;
    } else {
      return false;
    }
  }
  const validateemail = (email) => {
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    if (re.test(email)) {
      return true
    } else {
      return false
    }
  }
  const RegisterUser = async (type, id) => {
    if (name === "") {
      toast.error("Please Enter Name")
    } else if (mobilenumber === "") {
      toast.error("Please Enter Mobile Number")
    } else if (mobilenumber.length < 10) {
      toast.error("Please Enter Valid Mobile Number")
    } else if (email === "") {
      toast.error("Please Enter Email")
    } else if (!validateemail(email)) {
      toast.error("Please Enter Valid Email")
    } else if (buyertype === "") {
      toast.error("Please Select Buyer Type")
    } else if (vehicletype === "") {
      toast.error("Please Select Vehicle Type")
    } else if (vehiclenumber === "") {
      toast.error("Please Enter Vehicle Number")
    } else if (!validatevehicleno(vehiclenumber)) {
      toast.error("Please Enter Valid Vehicle Number")
    } else if (gstnumber === "" && (aadharno === "" || dob === "" || !validateaadharno(aadharno))) {
      if (gstnumber === "" && aadharno === "" && dob === "" && !validateaadharno(aadharno)) {
        toast.error("Please Enter GST Number")

      } else {
        if (aadharno === "") {
          toast.error("Please Enter Aadhar Number")
        } else if (!validateaadharno(aadharno)) {
          toast.error("Please Enter Valid Aadhar Number")
        }
        else if (dob === "") {
          toast.error("Please Enter Date of Birth")
        }
      }




    } else if (gstnumber !== "" && (aadharno === "" || dob === "") && !validategst(gstnumber)) {
      toast.error("Please Enter Valid GST Number")
    } else if (address === "") {
      toast.error("Please Enter Address")
    } else {

      if (type === "new") {
        var customer_id = `buyer${randomUsername()}`
        const { data: user, error1 } = await supabase
          .from('User_Details')
          .insert([
            { user_id: customer_id, user_name: name, user_type: "Buyer", user_phone: parseInt("91" + mobilenumber), user_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/Customer/profile.jpg", user_email: email, user_aadhar_no: aadharno, user_dob: dob },
          ])

        if (user !== null) {
          const { data, error } = await supabase
            .from('Buyer_details')
            .insert([
              { customer_id: customer_id, customer_email: email, createdBy: window.localStorage.getItem("useremail"), customer_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/Customer/profile.jpg", customer_name: name, customer_address: address, customer_phone: parseInt("91" + mobilenumber), customer_dob: dob, customer_aadhar_no: parseInt(aadharno), customer_vehiclenumber: vehiclenumber, customer_vehicletype: vehicletype, customer_type: buyertype, customer_gstnumber: gstnumber },
            ])

          if (data !== null) {


            toast.success(`Buyer Created Successfully`)
            setLarge(!Large)
            getBuyerdetail()


          } else {
            toast.error(error.message)
          }
        } else {
          toast.error("Error in Creating Buyer")
        }
      } else {
        customer_id = id
        const { data: user, error1 } = await supabase
          .from('User_Details')
          .update(
            { user_name: name, user_type: "Buyer", user_phone: parseInt("91" + mobilenumber), user_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/Customer/profile.jpg", user_email: email, user_aadhar_no: aadharno, user_dob: dob },
          )
          .eq('user_id', customer_id)

        if (user !== null) {
          const { data, error } = await supabase
            .from('Buyer_details')
            .update(
              { customer_email: email, createdBy: window.localStorage.getItem("useremail"), customer_pic: "https://sherrlhgyvpurdlcroky.supabase.co/storage/v1/object/public/Customer/profile.jpg", customer_name: name, customer_address: address, customer_phone: parseInt("91" + mobilenumber), customer_dob: dob, customer_aadhar_no: parseInt(aadharno), customer_vehiclenumber: vehiclenumber, customer_vehicletype: vehicletype, customer_type: buyertype, customer_gstnumber: gstnumber },
            )
            .eq('customer_id', customer_id)

          if (data !== null) {


            toast.success(`Buyer Updated Successfully`)
            setLarge(!Large)
            getBuyerdetail()


          } else {
            toast.error(error.message)
          }
        } else {
          toast.error("Error in Creating Buyer")
        }
      }
    }



  }
  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Buyer Details" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Modal isOpen={Large} toggle={LargeModaltoggle} size="lg" centered>
              <ModalHeader toggle={LargeModaltoggle}>
                {edittype === "new" ? "Register" : "Update"} Here For  Buyer
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col>

                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Name<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="text" placeholder="Enter Your Name" value={name} onChange={(e) => { setname(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Address<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="text" placeholder="Enter Your Address" value={address} onChange={(e) => { setAddress(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Mobile No<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText><Icon icon="twemoji:flag-india" width="25" height="25" /></InputGroupText>
                          </InputGroupAddon>
                          <Input className="form-control digits" type="number" placeholder="Enter Your Mobile No" value={mobilenumber} onChange={(e) => { e.target.value.length < 10 ? setmobilenumber(e.target.value) : setmobilenumber(e.target.value.slice(0, 10)) }} />
                        </InputGroup>
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label"> Email<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="email" placeholder='Enter Your Email' value={email} onChange={(e) => { setemail(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">GST No<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="text" placeholder="Enter Your GST No" value={gstnumber} onChange={(e) => { setgstnumber(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <hr></hr>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label"> Aadhar No</Label>
                      <Col sm="12">
                        <Input className="form-control" type="number" placeholder='Enter Your Aadhar No' value={aadharno} onChange={(e) => { setaadharno(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label"> Date Of Birth</Label>
                      <Col sm="12">
                        <Input className="form-control" type="date" placeholder='Enter Your Date of Birth' value={dob} onChange={(e) => { setdob(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Buyer Type<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">

                        <Input className="form-control" type="select" value={buyertype} onChange={(e) => {
                          setbuyertype(e.target.value)
                        }}>
                          <option value={""}>Choose Your Buyer Type</option>
                          {customer_type.map((data, i) => {

                            return (
                              <option key={i} value={data.customer_type}>{data.customer_type}</option>
                            )
                          })}
                        </Input>
                      </Col>
                    </FormGroup>

                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Vehicle Type<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="select" value={vehicletype} onChange={(e) => { setvehicletype(e.target.value) }}>
                          <option value={""}>Choose Your Vehicle Type</option>
                          {vehicle_type.map((data, i) => {

                            return (
                              <option key={i} value={data.vehicle_type}>{data.vehicle_type}</option>
                            )
                          })}
                        </Input>

                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Vehicle No<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="text" placeholder="Enter Your Vehicle No" value={vehiclenumber} onChange={(e) => {
                          setvehiclenumber(e.target.value)
                        }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="mb-0 mt-3">


                      <Button color="primary" className="btn-block" onClick={() => {
                        RegisterUser(edittype, editid)
                      }}>PROCEED </Button>
                    </FormGroup>






                  </Col>
                </Row>
              </ModalBody>
            </Modal>
            {window.innerWidth < 800 ? <>
              <div style={{ textAlign: "right",padding:"5px" }}>
                <button className='btn' style={{ fontSize: "13px", padding: "10px", boxShadow: "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)", borderRadius: "10px", backgroundColor: "#E50014", color: "white" }} onClick={() => {
                  LargeModaltoggle(); setedittype("new")
                  seteditid("")
                }}>Create Buyer</button>
              </div>

              <div style={clientHeight !== "" ? { height: clientHeight + "px", overflowY: "scroll", padding: "5px" } : { height: "100%" }}>
                <Accordion>

                  <div className="default-according" id="accordionclose">

                    {buyer_detail.length > 0 ? <>
                      {buyer_detail.map((data, i) => {
                        return (
                          <Card key={i} style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px" }}>
                            <CardHeader onClick={() => { document.getElementById(`one${i + 1}`).click() }} style={{ cursor: "pointer", borderRadius: "10px" }}>
                              <h5 className="mb-0" style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}>
                                <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" eventKey={i + 1} id={"one" + (i + 1)} style={{ padding: "0px" }}>
                                  <div className="email-app-sidebar left-bookmark">
                                    <div className="media" style={{ alignItems: "center " }}>
                                      <div className="media-size-email"><img src={data.customer_pic} alt="buyer_image" height={"40px"} width={"40px"} style={{ borderRadius: "10px" }} />
                                      </div>
                                      <div className="media-body" style={{ textAlign: "left", marginLeft: "20px" }}>

                                        <span style={{ display: "block" }}>{data.customer_name}</span>
                                        <span style={{ display: "block" }}>{data.customer_address}</span>

                                      </div>


                                    </div>
                                  </div>



                                </Accordion.Toggle>
                                <div className="media-size-email" style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "row",
                                }}> <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#dfffe4", padding: "5px", cursor: "pointer" }} onClick={() => {
                                  UpdateUser(data.customer_id)
                                }}><Icon icon="bxs:edit" color="darkgreen" width="30" height="30" /></div>
                                  &nbsp;
                                  <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#efc6ca", padding: "5px", cursor: "pointer" }} onClick={() => {
                                    DeleteUser(data.customer_id)
                                  }}><Icon icon="bi:trash" color="#E50014" width="25" height="25" /></div>



                                </div>
                              </h5>
                            </CardHeader>
                            <Accordion.Collapse eventKey={i + 1} style={{ borderRadius: "10px" }}>
                              <CardBody>
                                <div className="email-app-sidebar left-bookmark">
                                  <div className="media" >

                                    <div className="media-body" style={{ textAlign: "left" }}>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Buyer Type</span>
                                      <span style={{ display: "block" }}>{data.customer_type} </span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}> Phone</span>
                                      <span style={{ display: "block" }}>{data.customer_phone.toString().slice(2, 12)}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}> Email</span>
                                      <span style={{ display: "block" }}>{data.customer_email}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Vehicle Type</span>
                                      <span style={{ display: "block" }}>{data.customer_vehicletype}</span>


                                    </div>
                                    <div className="media-body" style={{ textAlign: "left" }}>
                                      
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Vehicle Number</span>
                                      <span style={{ display: "block" }}>{data.customer_vehiclenumber}</span>


                                    </div>


                                  </div>


                                </div>


                              </CardBody>
                            </Accordion.Collapse>
                          </Card>
                        )


                      })}</> : <Card>
                      <CardHeader >
                        <h5 className="mb-0">
                          <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" >
                            No Record Found
                          </Accordion.Toggle>
                        </h5>
                      </CardHeader>
                    </Card>}
                  </div>

                </Accordion>
              </div></> :
              <Card>
                <CardHeader>
                  <button className='btn btn-primary' style={{ float: "right" }} onClick={() => {
                    LargeModaltoggle(); setedittype("new")
                    seteditid("")
                  }}>Create Buyer</button>

                </CardHeader>
                <CardBody>
                  <div className="table-responsive ">
                    <Table>
                      <thead>
                        <tr style={{ textAlign: "center" }}>
                          <th scope="col">{"Sr.No"}</th>
                          <th scope="col">{"Buyer Image"}</th>
                          <th scope="col">{"Buyer Name"}</th>
                          <th scope="col">{"Buyer Email"}</th>
                          <th scope="col">{"Buyer Phone"}</th>
                          {/* <th scope="col">{"Buyer Address"}</th> */}
                          {/* <th scope="col">{"Buyer GST Number"}</th> */}
                          <th scope="col">{"Buyer Type"}</th>
                          <th scope="col">{"Buyer Vehicle Type"}</th>
                          {/* <th scope="col">{"Buyer Vehicle Number"}</th>
                      <th scope="col">{"Buyer Aadhar No"}</th>
                      <th scope="col">{"Buyer DOB"}</th> */}
                          <th scope="col">{"Action"}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {buyer_detail.length > 0 ? <>
                          {buyer_detail.map((data, i) => {
                            return (
                              <tr key={i} style={{ textAlign: "center" }}>
                                <th scope="row">{i + 1}</th>
                                <td><img src={data.customer_pic} alt="buyer_image" height={"40px"} width={"40px"} style={{ borderRadius: "10px" }} /></td>
                                <td>{data.customer_name}</td>
                                <td>{data.customer_email}</td>
                                <td>{data.customer_phone.toString().slice(2, 12)}</td>
                                {/* <td>{data.customer_address}</td> */}
                                {/* <td>{data.customer_gstnumber}</td> */}
                                <td>{data.customer_type}</td>
                                <td>{data.customer_vehicletype}</td>
                                {/* <td>{data.customer_vehiclenumber}</td> */}
                                {/* <td>{data.customer_aadhar_no}</td>
                            <td>{data.customer_dob}</td> */}
                                <td><button className='btn btn-warning' onClick={() => {
                                  UpdateUser(data.customer_id)
                                }}><i className='fa fa-edit '></i></button> &nbsp;<button className='btn btn-danger' onClick={() => {
                                  DeleteUser(data.customer_id)
                                }}><i className='fa fa-trash'></i></button></td>
                              </tr>
                            )
                          })}
                        </>
                          : <tr style={{ textAlign: "center" }}><td colSpan="12" style={{ textAlign: "center" }}>No Record Found</td></tr>}
                        {/* <tr style={{textAlign:"center"}}>
                      <th scope="row">{"1"}</th>
                      <td>{"Alexander"}</td>
                      <td>{"Orton"}</td>
                      <td>{"@mdorton"}</td>
                      <td>{"Admin"}</td>
                      <td>{"USA"}</td>
                    </tr> */}

                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>}

          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default Buyer;